import { UUID } from '@cmg/common';

import { useIsOfferingAuthor_OfferingQuery } from './graphql';

export const useOfferingAuthor = (offeringId: UUID | undefined) => {
  const { data, loading, error } = useIsOfferingAuthor_OfferingQuery({
    variables: { offeringId: offeringId! },
    skip: offeringId === undefined,
    errorPolicy: 'all',
  });

  const isOfferingAuthor =
    data?.privateOfferings?.items?.[0]?.isAuthor ??
    data?.publishedOfferings?.items?.[0]?.isAuthor ??
    false;

  return { isOfferingAuthor, loading, error };
};
